export default "__VITE_ASSET__9012db57__"